export default "__VITE_ASSET__DPDVmLsn__"